export default __webpack_public_path__ + "static/media/block-video.d2f973f2.svg";